// extracted by mini-css-extract-plugin
export default {"sendEmailDrawer":"styles_sendEmailDrawer__e86v+","shadowDisabled":"styles_shadowDisabled__1ZGUi","emailPreview":"styles_emailPreview__PhGa-"};